import * as Website from '../../Config/Website.js';
import * as Parallax from '../../Modules/Parallax.js';
import * as Splash from './Modules/Splash.js';


const preinit = () => {

}

const init = () => {
  Parallax.init();
  Splash.init();
}

const pageChanged = () => {
  Parallax.init();
  Splash.init();
}

const resize = () => {
  Parallax.resize();
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}